import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';

angular
  .module('cxSettings')
  .controller('PreviewInvoiceTemplateDialogCtrl', [
    '$element',
    '$http',
    '$timeout',
    '$filter',
    'close',
    'appUrls',
    'documentTemplateId',
    'documentUrl',
    'sampleTemplateId',
    'sampleTemplateType',
    'flySvc',
    'enumCacheSvc',
    'checkFeature',
    previewInvoiceTemplateDialogCtrl,
  ]);

function previewInvoiceTemplateDialogCtrl(
  $element,
  $http,
  $timeout,
  $filter,
  close,
  appUrls,
  documentTemplateId,
  documentUrl,
  sampleTemplateId,
  sampleTemplateType,
  flySvc,
  enumCacheSvc,
  checkFeature,
) {
  var vm = this;
  vm.loadingPreview = true;
  vm.invoicePreviewImage = null;
  vm.selectedRelationType = [0];
  vm.selectedNumberOfAssignments = 0;
  vm.assignmentOptions = [0, 1, 2];
  vm.addAdministrativeCost = false;
  vm.setInvoiceToDirectDebit = false;
  const allowedResourceTypes = [0, 1, 2];
  const mapTemplateTypeToInvoiceType = {
    11: 1,
    12: 4,
    14: 5,
    15: 2,
    16: 3,
    25: 6,
  };
  enumCacheSvc.get('resourceType').then(function(data) {
    vm.resourceTypeOptions = data
      .filter(x => allowedResourceTypes.includes(x.key))
      .map(x => ({
        key: x.key,
        value: x.value,
        label: x.value,
      }));
    translateResourceLabels();
    vm.selectedResourceTypes = allowedResourceTypes;
    enumCacheSvc.get('invoiceType').then(function(invoiceData) {
      vm.invoiceTypeOptions = invoiceData.map(x => ({
        key: x.key,
        value: x.value,
        label: x.value,
      }));
      if (!checkFeature('IntraCompanyBilling')) {
        vm.invoiceTypeOptions = vm.invoiceTypeOptions.filter(x => x.value !== 'IntraCompany');
      }
      translateInvoiceLabels();
      enumCacheSvc.get('templateType').then(function(templateData) {
        vm.templateTypes = templateData.map(x => ({
          key: x.key,
          value: x.value,
          label: x.value,
        }));
        const hiddenTemplayeTypes = [11, 12, 14, 15, 16, 25];
        vm.showInvoiceTypeButtons = !hiddenTemplayeTypes.includes(sampleTemplateType);
        vm.selectedInvoiceType = mapTemplateTypeToInvoiceType[sampleTemplateType] ?? 1;
        vm.generatePreview();
      });
    });
  });

  function translateResourceLabels() {
    vm.resourceTypeOptions.forEach(function(item) {
      item.label = $filter('translateList')(item.key, 'resourceType', item.value);
    });
  }
  function translateInvoiceLabels() {
    vm.invoiceTypeOptions.forEach(function(item) {
      item.label = $filter('translateList')(item.key, 'invoiceType', item.value);
    });
  }

  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };

  vm.toggleResourceType = function(id) {
    const idx = vm.selectedResourceTypes.indexOf(id);
    if (idx === -1) {
      vm.selectedResourceTypes.push(id);
    } else {
      vm.selectedResourceTypes.splice(idx, 1);
    }
  };
  vm.toggleInvoiceType = function(id) {
    vm.selectedInvoiceType = id;
  };

  vm.generatePreview = function() {
    var url = '';
    if (sampleTemplateId && sampleTemplateType >= 0) {
      url = `${
        appUrls.api
      }/Api/DraftInvoice/PreviewSampleTemplate?id=${sampleTemplateId}&templateType=${sampleTemplateType}&now=${new Date().getTime()}`;
    } else if (documentTemplateId) {
      url = `${
        appUrls.api
      }/Api/DraftInvoice/PreviewTemplate/${documentTemplateId}?now=${new Date().getTime()}`;
    } else if (documentUrl) {
      vm.invoicePreviewImage = `${documentUrl}?now=${new Date().getTime()}`;
      vm.loadingPreview = false;
    }
    if (!url) return;

    const params = new URLSearchParams();
    params.append('relationType', vm.selectedRelationType);
    params.append('numberOfAssignments', vm.selectedNumberOfAssignments);
    params.append('addAdministrativeCost', vm.addAdministrativeCost);
    params.append('setInvoiceToDirectDebit', vm.setInvoiceToDirectDebit);
    params.append('invoiceType', vm.selectedInvoiceType);
    vm.selectedResourceTypes.forEach(t => params.append('selectedResourceTypes', t));

    if (params.toString()) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + params.toString();
    }

    vm.loadingPreview = true;
    vm.invoicePreviewImage = null;
    $http
      .get(url, {
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          vm.loadingPreview = false;
          if (!response || !response.data) return;
          var blob = new Blob([response.data], { type: 'image/png' });
          var reader = new FileReader();
          reader.onload = function(evt) {
            $timeout(function() {
              vm.invoicePreviewImage = evt.target.result;
            }, 0);
          };
          reader.readAsDataURL(blob);
        },
        error => {
          vm.loadingPreview = false;
          showArrayBufferError(error);
        },
      );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
